// react-router-dom components
import { Link } from "react-router-dom";
import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { useMediaQuery } from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

import DashboardLayout from "pages/components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/DashboardNavbar";
import AssetsTreeList from "./components/AssetsTreeList";

const AssetsTree = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);
  const [refresh, setRefresh] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems="flex-start"
            p={3}
          >
            <SoftTypography>Assets Tree</SoftTypography>
          </Stack>
          <AssetsTreeList
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            selectedNode={selectedNode}
            setSelectedNode={setSelectedNode}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
};

export default AssetsTree;
